import React, { useState } from "react";
import _ from "lodash";
import { Box, Text } from "@showitinc/showit-wc";
import DomainListRow from "./domainmanager/DomainListRow";
import LoadingSpinner from "./LoadingSpinner";
import When from "./utils/When";
import useUserBlogDomains from "../hooks/query/useUserBlogDomains";
import styles from "./BlogDomainSelector.module.css";

const BlogDomainSelector = ({
  value, // wp_host_id
  onChange,
  propName,
  height = "360px",
  defaultLabel = "No Blog Domain",
}) => {
  const [state, setState] = useState({
    value,
    initValue: value,
  });

  const { blogDomains, isLoading, isError, isSuccess } = useUserBlogDomains();

  const _selectDomain = (domain, e) => {
    const value = domain.wp_host_id;

    setState((prev) => ({ ...prev, value }));
    if (onChange) {
      const propInfo = _getPropInfo(value);
      onChange(propInfo, e);
    }
  };

  const _getPropInfo = (value) => ({
    name: propName,
    origValue: state.initValue,
    value,
  });

  const _getDomainList = () => {
    const { value } = state;

    if (blogDomains?.length === 0) {
      return (
        <div className={styles.viewCentered} style={{ flexDirection: "column" }}>
          <div style={{ fontSize: "1.25rem", padding: "1.25rem" }}>
            No blog domains currently available.
          </div>
        </div>
      );
    } else {
      const domainList = [
        ...(blogDomains || []),
        {
          domain_name: defaultLabel,
          wp_host_id: null,
          design_name: null,
        },
      ];

      const selectedDomain = _.find(blogDomains, { wp_host_id: value });
      const domainName = selectedDomain ? selectedDomain.domain_name : defaultLabel;
      const listItems = domainList.map((domain, index) => (
        <DomainListRow
          key={index}
          domain={domain}
          selected={domain.wp_host_id === value}
          onClick={_selectDomain.bind(this, domain)}
        />
      ));

      return (
        <div style={{ height }}>
          <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <Box d="flex" flex="column" mt="4" gp="2" align="center">
              <Text variant="header-1">Blog Domain: </Text>
              <Text variant="subtitle" variantStyle="strong">
                {domainName}
              </Text>
            </Box>
            <div className="si-table selectable no-pad">{listItems}</div>
          </div>
        </div>
      );
    }
    const domainList = [
      ...(blogDomains || []),
      {
        domain_name: defaultLabel,
        wp_host_id: null,
        design_name: null,
      },
    ];

    const selectedDomain = _.find(blogDomains, { wp_host_id: value });
    const domainName = selectedDomain ? selectedDomain.domain_name : defaultLabel;
    const listItems = domainList.map((domain, index) => (
      <DomainListRow
        key={index}
        domain={domain}
        selected={domain.wp_host_id === value}
        onClick={_selectDomain.bind(this, domain)}
      />
    ));

    return (
      <div style={{ height }}>
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <div style={{ margin: "24px 0" }}>
            <span className={styles["domain-label"]}>Blog Domain:</span>
            <span>{domainName}</span>
          </div>
          <div className="si-table selectable">{listItems}</div>
        </div>
      </div>
    );
  };

  return (
    <>
      <When it={isLoading}>
        <div className={styles.viewCentered} style={{ flexDirection: "column" }}>
          <div className={styles["loading-text"]}>Loading</div>
          <LoadingSpinner />
        </div>
      </When>
      <When it={isError}>
        <div className={styles.viewCentered} style={{ flexDirection: "column" }}>
          <div>Error: Unable to get blog domain list</div>
        </div>
      </When>
      <When it={isSuccess && blogDomains !== undefined}>{_getDomainList()}</When>
    </>
  );
};

export default BlogDomainSelector;
